/* Core & libraries */
import React, {useEffect, useRef, useState} from "react";
import {useTheme} from "react-jss";
import {FormattedMessage} from "react-intl";
import { Formik, Field, ErrorMessage } from "formik";


/* Helpers, constants, custom methods, internal libraries */
import { usePeopleService  } from "../../../services/peopleService";
import { useGlobalContext, useGlobalUpdateContext } from "../../../contexts/globalContext";


/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import {ReactComponent as InvitePeopleSvg} from '../../../resources/images/user-plus-02.svg';

/* Styles */
import styles from "./styles";
import {useUserContext} from "../../../contexts/userContext";


const InvitePeopleModal = () => {

  const theme = useTheme();
  const classes = styles({theme});
  const { sendInvite } = usePeopleService();
  const globalProperties  = useGlobalContext();
  const setGlobalProperties  = useGlobalUpdateContext();
  const userDetails = useUserContext();
  const { invitationCount , getPendingInviteCount } = usePeopleService();

  const handleSendInvites = async (values) => {
    //TODO: add validation
    if (globalProperties?.invitePeopleModal?.teamId) {
      values.groupEntityId = globalProperties.invitePeopleModal.teamId
    }
    if (!globalProperties?.invitePeopleModal?.companyEntityId) {
      values.companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId
    }
    const response = await sendInvite(values)
    if (response) {
      setInvitePeopleModal(false)
      getPendingInviteCount()
    }
  }

  const setInvitePeopleModal = (status) => {
    setGlobalProperties({
      ...globalProperties,
      invitePeopleModal: {
        ...globalProperties.invitePeopleModal,
        showInvitePeopleModal: status,
      },
      inviteCount: invitationCount
    })
  }

  return (
    <UCModal
      className={classes.invitePeopleModal}
      showModal={globalProperties?.invitePeopleModal?.showInvitePeopleModal}
      setShowModal={setInvitePeopleModal}
      modalIcon={<InvitePeopleSvg/>}
      modalTitle={<FormattedMessage id="invitepeoplemodal.title"/>}
      modalDescription={<p className={classes.invitePeopleDescription} tabIndex={0}>{globalProperties?.invitePeopleModal?.isNotDefault ? <FormattedMessage id="invitepeoplemodal.notDefaultTeamDescription"/> :  <FormattedMessage id="invitepeoplemodal.description"/>} {globalProperties?.invitePeopleModal?.teamName}</p>}
      modalContent={
        <Content 
          setShowModal={setInvitePeopleModal} 
          sharedLink={globalProperties?.invitePeopleModal?.sharedLink} 
          handleSendInvites={handleSendInvites}        
          active={globalProperties?.invitePeopleModal?.active}
          requiresDomain={globalProperties?.invitePeopleModal?.requiresDomain}
        />
      }
      dataTestId="invitePeopleModal"
    />
  )
}

export default InvitePeopleModal;
